import React, { useRef, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';


function InfiniteList ({ children, className, fetchMore, isFetchingMore, spinner, hasMore }) {
  const sentinel = useRef(null);

  const onFetchMore = useCallback(entries => {
    if (entries.some(entry => entry.isIntersecting)) {
      fetchMore();
    }
  }, [isFetchingMore]
  );

  useEffect(() => {
    const observer = new IntersectionObserver(onFetchMore);
    if (sentinel && sentinel.current) {
      observer.observe(sentinel.current);
    }
  }, [sentinel]);

  return (
    <ul className={className}>
      {children}
      {renderSentinel()}
      {renderSpinner()}
    </ul>
  );


  function renderSentinel () {
    return hasMore && <li ref={sentinel} style={{ height: '1px', margin: '1px' }}></li>;
  }

  function renderSpinner () {
    return isFetchingMore && spinner;
  }
}

InfiniteList.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  fetchMore: PropTypes.func,
  isFetchingMore: PropTypes.bool,
  spinner: PropTypes.element,
  hasMore: PropTypes.bool,
};


export default InfiniteList;
